/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The tab of the page history: company-wide changes to defaults and exceptions, or job edits.
 *
 */
export enum PolicyHistoryCategory {
    DEFAULTS_AND_EXCEPTIONS = 'defaultsAndExceptions',
    JOB_EDITS = 'jobEdits',
}
